import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ContactModalProvider } from "@/context/ContactModalContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

const PAGE_TITLES = {
  "/": "Sable Advisory — Home",
  "/services": "Sable Advisory — Services",
  "/about": "Sable Advisory — About",
  "/contact": "Sable Advisory — Contact",
};

const PageTitle = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = PAGE_TITLES[pathname] || "Sable Advisory";
  }, [pathname]);

  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PageTitle />
        <ContactModalProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
          </Routes>
          <Toaster
            position="bottom-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#111111",
                color: "#F2EFE8",
                border: "1px solid rgba(198,169,107,0.25)",
              },
            }}
          />
        </ContactModalProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
